import { Translate } from "react-admin";

// Flattens a (possibly nested) class-validator error object into
// "path: reason" lines, e.g. { bannerSlogans: "must be...", cover: { formImage: "..." } }
// -> ["bannerSlogans: must be...", "cover.formImage: ..."].
const flattenErrors = (
  errors: Record<string, any> | undefined,
  prefix = ""
): string[] => {
  const lines: string[] = [];
  for (const [key, value] of Object.entries(errors || {})) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (value && typeof value === "object") {
      lines.push(...flattenErrors(value, path));
    } else if (value) {
      lines.push(`${path}: ${value}`);
    }
  }
  return lines;
};

// The backend (see pl-back's ResponseException/ValidationException) replies
// with either a plain human-readable sentence ("Not valid request") or an
// i18n-style key ("errors.invalidRequest", "errors.notFound", ...) plus an
// optional `errors` map of per-field validation messages. This turns
// whatever comes back - that shape, a network-level Axios error with no
// response, or anything else - into one human-readable line, translating
// the backend's key-style messages via the same i18nProvider (see the
// "errors"/"customErrors" namespaces) and falling back to the string
// itself when there's no matching translation.
export const getErrorMessage = (error: any, translate: Translate): string => {
  const data = error?.response?.data;

  if (data?.message) {
    const heading = translate(data.message, { _: data.message });
    const fieldLines = flattenErrors(data.errors);
    return fieldLines.length > 0
      ? `${heading}: ${fieldLines.join("; ")}`
      : heading;
  }

  if (error?.message) return error.message;

  return String(error ?? "");
};
